/* Copyright (c) 2026 Health Endeavors, LLC. All Rights Reserved */

import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';

import { useAppDispatch } from '../../../../app/hooks';
import { bookmarkCurrentDocumentThunk } from '../chatSlice';
import { DocumentVersionType } from '../../algorithm/types';
import styles from './DocumentVersionFavoriteButton.module.scss';
import { FavIcon } from './FavIcon';

export type DocumentVersionFavoriteButtonProps = {
  documentVersion: DocumentVersionType;
};

export function DocumentVersionFavoriteButton({ documentVersion }: DocumentVersionFavoriteButtonProps) {
  const dispatch = useAppDispatch();
  const isBookmarkedNow = documentVersion.bookmarkedByYou;
  const handleBookmark = (e: React.MouseEvent<HTMLButtonElement>) => {
    void dispatch(
      bookmarkCurrentDocumentThunk({
        bookmark: !isBookmarkedNow,
        documentId: documentVersion?.document.id,
      })
    );
    e.stopPropagation();
  };

  return (
    <Tooltip title={isBookmarkedNow ? 'Remove from favorites' : 'Add to favorites'}>
      <Button
        className={styles.favoriteButton}
        onClick={handleBookmark}
        variant="text"
        data-testid={isBookmarkedNow ? 'removeToFavourite' : 'addToFavourite'}
        endIcon={<FavIcon fill={isBookmarkedNow ? 'var(--indigonavyblue)' : 'none'} />}
      />
    </Tooltip>
  );
}
